module.exports = __webpack_public_path__ + "static/media/Graph-BFS.28065b90.gif";